import React from "react";
import { useTranslation } from "react-i18next";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TransportOrderListItemDto } from "../../../models/transport/transportOrder";
import { Translations } from "../../../models/translations";
import { Base } from "../../../framework/base";

interface SelectedOrderCardRowProps {
    title: string;
    text: string;
}

interface TransportOrderSelectedOrderCardProps {
    item: TransportOrderListItemDto;
}

export const TransportOrderSelectedOrderCard = ({ item }: TransportOrderSelectedOrderCardProps) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = React.useState(false);

    const getDeliveryDate = (date: string | null) => {
        if (date) {
            return Base.dayjsDateToDateTimeStr(date);
        }
        return "-";
    }

    const handleAccordionChange = () => {
        setExpanded(!expanded);
    };

    const SelectedOrderCardRow = ({ title, text }: SelectedOrderCardRowProps) => {
        return (
            <Grid2 container justifyContent="space-between" mb={1}>
                <Typography variant="h4" color="primary.dark" mb={1}> {title}: </Typography>
                <Typography variant="h4" color="secondary">{text}</Typography>
            </Grid2>
        );
    };

    return (
        <Grid2 mb={2}>
            <Accordion
                onChange={handleAccordionChange}
                expanded={expanded}
                sx={{ width: "100%" }}
            >
                <AccordionSummary
                    expandIcon={<KeyboardArrowDownIcon id="workTime-form-header" />}
                >
                    <Grid2 spacing={2}>
                        <Typography variant="h3" mb={1}>{item.name}</Typography>
                        <Grid2 container>
                            <Typography variant="h4" color="primary.dark" mb={1}> {Translations.OrderNumber}:</Typography>
                            <Typography ml={2} variant="h4" color="secondary">{item.orderNumber}</Typography>
                        </Grid2>
                    </Grid2>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid2>
                        <SelectedOrderCardRow title={t("transport.invoicing.totalPriceEUR")} text={item.totalSum.toFixed(2)} />
                        <SelectedOrderCardRow title={Translations.Delivered} text={getDeliveryDate(item.latestTransportTaskTypeChangedDateTime)} />
                    </Grid2>
                </AccordionDetails>
            </Accordion>
        </Grid2>
    );
};
